import { render, staticRenderFns } from "./SearchLocationNijmegen.vue?vue&type=template&id=4420a556&"
import script from "./SearchLocationNijmegen.vue?vue&type=script&lang=js&"
export * from "./SearchLocationNijmegen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports